<script>
import { nextTick } from 'vue'

import apiUsers from '@/api/api-users.js'
import apiCustomers from '@/api/api-customers.js'
import apiSettings from '@/api/api-settings'

import Table from './common/SortedTable.vue'
import EditForm from './common/EditForm.vue'
import MessageBoxQuestion from './common/MessageBoxQuestion.vue'

export default {
    name: 'UsersComponent',
    
    components: {
        Table,
        EditForm,
        MessageBoxQuestion
    },

    props: {
        userLanguage: {
            type: String,
            default: 'cz'
        },
        languageStrings: {
            type: Object,
            default: () => {}
        }
    },

    emits: ['form-closed'],

    computed: {
        headers() {
            return [
                {
                    id: 'lastname',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user001 != null ? this.languageStrings.ui.user001 : 'Příjmení',
                    sort: true
                },
                {
                    id: 'firstname',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user002 != null ? this.languageStrings.ui.user002 : 'Jméno',
                    sort: true
                },
                {
                    id: 'customer',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user007 != null ? this.languageStrings.ui.user007 : 'Zákazník',
                    sort: true
                },
                {
                    id: 'username',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user004 != null ? this.languageStrings.ui.user004 : 'Uživatelské jméno',
                    sort: true
                },
                {
                    id: 'role',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user005 != null ? this.languageStrings.ui.user005 : 'Role',
                    sort: true
                },
                {
                    id: 'protocol',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user006 != null ? this.languageStrings.ui.user006 : 'Protokol',
                    sort: true
                },
                {
                    id: 'active',
                    name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user026 != null ? this.languageStrings.ui.user026 : 'Aktivní',
                    sort: true
                }
            ]
        },
        rows() {
            let r = []
            for (let i = 0; i < this.filteredUsers.length; i++) {
                r.push({
                    id: this.filteredUsers[i].id,
                    selected: this.selectedUsers.length > 0 && this.filteredUsers[i].id === this.selectedUsers[0] ? true : false,
                    cells: [
                        {
                            id: 'lastname',
                            contenttype: 'text',
                            content: this.filteredUsers[i].lastName != null ? this.filteredUsers[i].lastName : '',
                        },
                        {
                            id: 'firstname',
                            contenttype: 'text',
                            content: this.filteredUsers[i].firstName != null ? this.filteredUsers[i].firstName : '',
                        },
                        {
                            id: 'customer',
                            contenttype: 'text',
                            content: this.filteredUsers[i].customer != null && this.filteredUsers[i].customer.name != null ? this.filteredUsers[i].customer.name : '',
                        },
                        {
                            id: 'username',
                            contenttype: 'text',
                            content: this.filteredUsers[i].userName != null ? this.filteredUsers[i].userName : '',
                        },
                        {
                            id: 'role',
                            contenttype: 'text',
                            content: this.filteredUsers[i].role != null && this.filteredUsers[i].role.id != null ? this.roleOptions.find(o => o.key === this.filteredUsers[i].role.id).value : '',
                        },
                        {
                            id: 'protocol',
                            contenttype: 'text',
                            content: this.filteredUsers[i].protocol != null ? this.filteredUsers[i].protocol : '',
                        },
                        {
                            id: 'active',
                            contenttype: 'text',
                            content: this.filteredUsers[i].active != null 
                                ? this.filteredUsers[i].active 
                                    ? (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form003 != null ? this.languageStrings.ui.form003 : 'Ano') 
                                    : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne') 
                                : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne')
                        }
                    ]
                })
            }
            return r
        },
        filteredUsers() {
            let usr = this.users
            if (this.filterValues.customer.length > 0) {
                usr = usr.filter(u => u.customer != null && u.customer.name != null && u.customer.name.toLowerCase().startsWith(this.filterValues.customer.toLowerCase()))                   
            }
            if (this.filterValues.surname.length > 0) {
                usr = usr.filter(u => u.lastName != null && u.lastName.toLowerCase().startsWith(this.filterValues.surname.toLowerCase()))  
            }
            if (this.filterValues.role > 0) {
                usr = usr.filter(u => u.role != null && u.role.id === this.filterValues.role)
            }
            if (this.filterValues.protocol > 0) {
                if (this.filterValues.protocol === 1) {
                    usr = usr.filter(u => u.protocol != null && u.protocol.length > 0)
                }
                else {
                    usr = usr.filter(u => u.protocol == null || u.protocol.length == 0)
                }
            }
            if (this.filterValues.active > 0) {
                if (this.filterValues.active === 1) {
                    usr = usr.filter(u => u.active != null && u.active)
                }
                else {
                    usr = usr.filter(u => u.active == null || !u.active)
                }
            }
            return usr
        }
    },

    data() {
        return {
            enums: {
                regions: []
            },

            saveButtonText: '',
            showEditForm: false,
            editFormTitle: '',
            editFormData: null,
            showSaveQuestion: false,
            filterValues: { customer: '', surname: '', role: 0, protocol: 0, active: 0 },
            selectedUsers: [],
            users: [],
            showMessageBoxQuestion: false,
            messageBoxQuestionText: '',
            messageBoxType: -1,
            messageBoxData: null,
            roleOptions: [
                { key: 1, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user007 != null ? this.languageStrings.ui.user007 : 'Zákazník') }, 
                { key: 2, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user008 != null ? this.languageStrings.ui.user008 : 'Technik') },
                { key: 3, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user009 != null ? this.languageStrings.ui.user009 : 'Servis') }, 
                { key: 4, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user010 != null ? this.languageStrings.ui.user010 : 'Administrátor') }, 
                { key: 5, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user011 != null ? this.languageStrings.ui.user011 : 'Laboratoř') }
            ]
        }
    },    

    async mounted() {
        let result = await apiSettings.getRegions()
        if (result.code === 0) {
            this.enums.regions = result.data
        }

        await this.loadUsers()

        await nextTick()
        document.getElementById('form').focus()
    },

    methods: {
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }
        },
        closeForm() {
            this.$emit('form-closed')
        },

        async loadUsers() {
            this.users = []
            let page = 1
            let pagesize = 15
            let dataLength = 0

            do {
                let response = await apiUsers.getUsers(page++, pagesize)
                if (response.code === 0) {
                    this.users.push(...response.data)
                    dataLength = response.data.length
                }
                else
                    break
            } while (dataLength === pagesize)
        },

        async newUser() {
            this.editFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user012 != null ? this.languageStrings.ui.user012 : 'Nový uživatel'
            this.saveButtonText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form001 != null ? this.languageStrings.ui.form001 : 'Uložit'
            this.showSaveQuestion = true            
            await this.getEditFormData(-1)
            this.showEditForm = true
        },

        async editUser() {
            if (this.selectedUsers.length > 0) {
                this.editFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user013 != null ? this.languageStrings.ui.user013 : 'Editace uživatele'
                this.saveButtonText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form001 != null ? this.languageStrings.ui.form001 : 'Uložit'
                this.showSaveQuestion = true            
                await this.getEditFormData(this.selectedUsers[0])
                this.showEditForm = true
            }
        },

        async deleteUser() {
            if (this.selectedUsers.length > 0) {
                this.messageBoxQuestionText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user022 != null ? this.languageStrings.ui.user022 : 'Smazat uživatele?'
                this.messageBoxType = 1
                this.showMessageBoxQuestion = true
            }
        },

        async getEditFormData(uId) {
            let user = this.users.find(u => u.id === uId)
            this.editFormData = {
                id: uId,
                type: 2,
                rows: [
                    {
                        name: 'username',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user004 != null ? this.languageStrings.ui.user004 : 'Uživatelské jméno',
                        value: user != null && user.userName != null ? user.userName : '',
                        required: true,
                        disabled: uId !== -1 ? true : false
                    },
                    {
                        name: 'password',
                        type: 'password',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user003 != null ? this.languageStrings.ui.user003 : 'Heslo',
                        value: ''
                    },
                    {
                        name: 'lastname',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user001 != null ? this.languageStrings.ui.user001 : 'Příjmení',
                        value: user != null && user.lastName != null ? user.lastName : '',
                    },
                    {
                        name: 'firstname',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user002 != null ? this.languageStrings.ui.user002 : 'Jméno',
                        value: user != null && user.firstName != null ? user.firstName : '',
                    },
                    {
                        name: 'email',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user023 != null ? this.languageStrings.ui.user023 : 'E-mail',
                        value: user != null && user.email != null ? user.email : '',
                    },
                    {
                        name: 'role',
                        type: 'options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user005 != null ? this.languageStrings.ui.user005 : 'Role',
                        options: this.roleOptions,
                        value: user != null && user.role != null ? user.role.id : 1
                    },
                    {
                        name: 'customer',
                        type: 'options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user007 != null ? this.languageStrings.ui.user007 : 'Zákazník',
                        options: [{ key: 0, value: '' }],
                        value: user != null && user.customer != null ? user.customer.id : 0,
                    },
                    {
                        name: 'protocol',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user006 != null ? this.languageStrings.ui.user006 : 'Protokol',
                        value: user != null && user.protocol != null ? user.protocol : '',
                    },
                    {
                        name: 'regions',
                        type: 'multiple-options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user024 != null ? this.languageStrings.ui.user024 : 'Regiony',
                        value: user != null && user.regions != null ? user.regions : [],
                        options: []
                    },
                    {
                        name: 'customers',
                        type: 'multiple-options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user025 != null ? this.languageStrings.ui.user025 : 'Oprávnění ke složce',
                        value: user != null && user.folderAccess != null ? user.folderAccess : [],
                        options: []
                    },
                    {
                        name: 'active',
                        type: 'checkbox',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user026 != null ? this.languageStrings.ui.user026 : 'Aktivní',
                        value: user != null && user.active != null ? user.active : '',
                    }
                ]
            }
            
            this.editFormData.rows[8].options.push(...this.enums.regions.slice().sort((a, b) => a.name.localeCompare(b.name)).map(r => ( { key: r.id, value: r.name } )))

            let response = await apiCustomers.getCustomers()
            if (response.code === 0) {
                let customers = response.data.slice().sort((a, b) => a.name.localeCompare(b.name))
                this.editFormData.rows[6].options.push(...customers.map(c => ( { key: c.id, value: c.name } )))
                this.editFormData.rows[9].options.push(...customers.map(c => ( { key: c.id, value: c.name } )))
            }
        },

        filter() {
            this.editFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user020 != null ? this.languageStrings.ui.user020 : 'Filtr'
            this.saveButtonText = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user021 != null ? this.languageStrings.ui.user021 : 'Filtrovat'
            this.showSaveQuestion = false

            this.editFormData = {
                id: -1,
                type: 1,
                rows: [
                    {
                        name: 'customer',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user007 != null ? this.languageStrings.ui.user007 : 'Zákazník',
                        value: this.filterValues.customer
                    },
                    {
                        name: 'surname',
                        type: 'text',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user001 != null ? this.languageStrings.ui.user001 : 'Příjmení',
                        value: this.filterValues.surname
                    },
                    {
                        name: 'role',
                        type: 'options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user005 != null ? this.languageStrings.ui.user005 : 'Role',
                        options: this.roleOptions,
                        value: this.filterValues.role
                    },
                    {
                        name: 'protocol',
                        type: 'options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user006 != null ? this.languageStrings.ui.user006 : 'Protokol',
                        options: [
                            { key: 0, value: '' }, 
                            { key: 1, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form003 != null ? this.languageStrings.ui.form003 : 'Ano') }, 
                            { key: 2, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne') }
                        ],
                        value: this.filterValues.protocol
                    },
                    {
                        name: 'active',
                        type: 'options',
                        text: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.user026 != null ? this.languageStrings.ui.user026 : 'Aktivní',
                        options: [
                            { key: 0, value: '' }, 
                            { key: 1, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form003 != null ? this.languageStrings.ui.form003 : 'Ano') }, 
                            { key: 2, value: (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'Ne') }
                        ],
                        value: this.filterValues.active
                    }
                ]
            }

            this.showEditForm = true
        },

        async editFormClosed(result, data) {
            this.showEditForm = false

            if (result === 0) {
                switch (data.type) {
                    case 1: // Filter
                        this.filterValues = { customer: data.rows[0].value, surname: data.rows[1].value, role: data.rows[2].value, protocol: data.rows[3].value, active: data.rows[4].value }
                        break

                    case 2: // User
                        if (data.id === -1) { // new
                            let result = await apiUsers.postUser({
                                userName: data.rows[0].value,
                                firstName: data.rows[3].value.length > 0 ? data.rows[3].value : '',
                                lastName: data.rows[2].value.length > 0 ? data.rows[2].value : '',
                                email: data.rows[4].value.length > 0 ? data.rows[4].value : '',
                                role: { id: data.rows[5].value },
                                customer: data.rows[6].value > 0 ? { id: data.rows[6].value, name: '', children: [] } : null,
                                protocol: data.rows[7].value.length > 0 ? data.rows[7].value : null,
                                userPassword: data.rows[1].value.length > 0 ? data.rows[1].value : '',
                                regions: data.rows[8].value,
                                folderAccess: data.rows[9].value,
                                active: data.rows[10].value
                            })
                            if (result.code === 0) {
                                await this.loadUsers()
                                this.selectedUsers = [ result.data.id ]
                            }
                        }
                        else { // edit
                            let u = this.users.find(u => u.id === data.id)
                            let result = await apiUsers.putUser({
                                id: data.id,
                                userName: data.rows[0].value,
                                firstName: data.rows[3].value.length > 0 ? data.rows[3].value : '',
                                lastName: data.rows[2].value.length > 0 ? data.rows[2].value : '',
                                email: data.rows[4].value.length > 0 ? data.rows[4].value : '',
                                role: { id: data.rows[5].value },
                                language: u.language != null ? u.language : null,
                                customer: data.rows[6].value > 0 ? { id: data.rows[6].value, name: '', children: [] } : null,
                                protocol: data.rows[7].value.length > 0 ? data.rows[7].value : null,
                                userPassword: data.rows[1].value.length > 0 ? data.rows[1].value : '',
                                regions: data.rows[8].value,
                                folderAccess: data.rows[9].value,
                                active: data.rows[10].value
                            })
                            if (result.code === 0) {
                                await this.loadUsers()
                                this.selectedUsers = [ result.data.id ]
                            }
                        }
                        break
                }
            }
        },

        setSelectedUsers(value) {
            this.selectedUsers = value
        },

        async messageBoxQuestionClosed(result) {
            this.showMessageBoxQuestion = false    

            if (result !== 0) {
                return
            }

            await apiUsers.deleteUser(this.selectedUsers[0])
            await this.loadUsers()
        }
    }
}
</script>

<template>
    <div class="form table-form users-form">
        <div id="form" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu024 != null ? languageStrings.ui.menu024 : 'Uživatelé' }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="form-wrapper">
                <div class="form-content rows gap-10">
                    <div class="cols justify-space-between">
                        <span class="cols gap-5">
                            <button class="button-small" @click="newUser()">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.user016 != null ? languageStrings.ui.user016 : 'Nový' }}</button>
                            <button class="button-small" @click="editUser()">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.user017 != null ? languageStrings.ui.user017 : 'Editovat' }}</button>
                        </span>
                        <button class="button-small" @click="filter()">...</button>
                    </div>                
                    <div class="scrollable">
                        <Table :headers="headers" :rows="rows" @selected-items="setSelectedUsers" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Edit form - user, filter -->
    <EditForm v-if="showEditForm" :title="editFormTitle" @form-closed="editFormClosed" :edit-data="editFormData" :user-language="userLanguage"
        :saveButtonText="saveButtonText"
        :cancelButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form002 != null ? languageStrings.ui.form002 : 'Zrušit'"
        :yesButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form003 != null ? languageStrings.ui.form003 : 'Ano'"
        :noButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form004 != null ? languageStrings.ui.form004 : 'Ne'"
        :saveText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form005 != null ? languageStrings.ui.form005 : 'Uložit změny?'"
        :showQuestion="showSaveQuestion"
    />
    <!-- Edit form - user, filter -->


    <!-- Message box - Question -->
    <MessageBoxQuestion v-if="showMessageBoxQuestion" :text="messageBoxQuestionText" @form-closed="messageBoxQuestionClosed" :type="messageBoxType" :data="messageBoxData"
        :yesButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form003 != null ? languageStrings.ui.form003 : 'Ano'"
        :noButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form004 != null ? languageStrings.ui.form004 : 'Ne'"
    />
    <!-- Message box - Question -->
</template>